import { API } from 'aws-amplify';

import { createAiPrompt, updateAiPrompt } from '../../graphql/customMutations';
import { listAiPromptsByKey } from '../../graphql/customQueries';
import { currentUserIdentity } from '../../utils/currentUser';

// The prompt this admin page manages (mockup page 24 = the DQF AI Evaluation prompt).
export const AUDIT_PROMPT_KEY = 'dqf-audit';

// The audit worker inserts the client's checklist where this placeholder appears
// (renderAuditPrompt in cp-dqf-audit lambda/prompt.ts does a plain string replace). A prompt saved
// without it still runs, but the substitution is a silent no-op: the evaluation goes to the model
// with no client rules at all, while the run still records qualListAvailable: true. That happened
// on dev between 2026-08-06 and 2026-08-17, so Save blocks on it.
export const RULES_PLACEHOLDER = '{{RULES}}';

export const isMissingRulesPlaceholder = body => !String(body || '').includes(RULES_PLACEHOLDER);

// The active version row for a key (the current prompt). Newest-first; prefer the row flagged
// active, else the highest version. Returns null if none stored yet.
export const getActivePrompt = async (promptKey = AUDIT_PROMPT_KEY) => {
  try {
    const response = await API.graphql({
      query: listAiPromptsByKey,
      variables: { promptKey, sortDirection: 'DESC', limit: 20 },
    });
    const items = response?.data?.listAiPromptsByKey?.items || [];
    return items.find(p => p.active) || items[0] || null;
  } catch (e) {
    console.log(`Error loading prompt: ${JSON.stringify(e)}`);
    return null;
  }
};

// Append-only save (guardrail 3 reportability): write a new active version, then deactivate the
// previous active row so history is preserved and the workers pick up the new wording.
export const savePrompt = async (promptKey, body, current) => {
  const { email, fullName } = await currentUserIdentity();
  const nextVersion = (current?.version || 0) + 1;
  await API.graphql({
    query: createAiPrompt,
    variables: {
      input: {
        promptKey,
        version: nextVersion,
        body,
        active: true,
        updatedByEmail: email,
        updatedByFullName: fullName,
      },
    },
  });
  if (current?.id) {
    await API.graphql({ query: updateAiPrompt, variables: { input: { id: current.id, active: false } } });
  }
};
